const datas = [
  { id: 0, name: "個人傷害險" },
  { id: 1, name: "團體傷害險" },
  { id: 2, name: "意外險" },
  { id: 3, name: "醫療險" }
];

export default datas;

export const contract_type_enum = window._.keyVal(datas, "id", "name");
